module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master (1).8c2c857d.svg";